(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["northmire-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('northmire-product-details')) {
  customElements.define('northmire-product-details', class extends HTMLElement {
    connectedCallback() {
      const clean = () => {
        const body = this.querySelector('.nm-product-copy__body');
        if (!body || this.dataset.cleaned) return;
        this.dataset.cleaned = 'true';
        const normalize = text => text.normalize('NFKC').toLowerCase().replace(/[\u2010-\u2015]/g, '-').replace(/\s+/g, ' ').replace(/[.\s:;]+$/g, '').trim();
        const entries = [];
        const leaves = [...body.querySelectorAll('p,li,tr')].filter(el => !el.querySelector('p,li,tr') && !el.querySelector('img,video,iframe'));
        for (const el of leaves) {
          const text = normalize(el.textContent);
          if (!text) { el.hidden = true; continue; }
          const duplicate = entries.some(previous => previous === text || (text.length > 24 && previous.includes(text)));
          if (duplicate) { el.hidden = true; continue; }
          entries.push(text);
        }
        const description = this.querySelector('[data-nm-description]');
        const descriptionText = normalize([...description.querySelectorAll('p,li,tr')].filter(el => !el.hidden).map(el => el.textContent).join(' '));
        const specs = this.querySelector('[data-nm-specifications]');
        if (specs) {
          for (const el of specs.querySelectorAll('p,li,tr')) {
            if (el.hidden || el.querySelector('p,li,tr')) continue;
            const text = normalize(el.textContent);
            const parts = text.split(/:\s*/);
            if (parts.length !== 2 || parts[1].length < 4) continue;
            const labelWords = parts[0].match(/[a-z0-9]+/g) || [];
            const value = parts[1];
            if (descriptionText.includes(value) && labelWords.length && labelWords.every(word => descriptionText.includes(word))) el.hidden = true;
          }
        }
        for (const list of body.querySelectorAll('ul,ol,table')) {
          const items = [...list.querySelectorAll('li,tr')];
          if (items.length && items.every(el => el.hidden)) list.hidden = true;
        }
        for (const heading of body.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
          if (/^(description|details|specifications|product specifications|product details|description & specifications)$/i.test(heading.textContent.trim())) heading.hidden = true;
        }
      };
      const setup = () => {
        clean();
        const body = this.querySelector('.nm-product-copy__body');
        const content = this.querySelector('.nm-product-copy__content');
        const toggle = this.querySelector('.nm-product-copy__toggle');
        if (!body || !content || !toggle || this._readMoreController) return;
        this._readMoreController = new AbortController();
        this.dataset.expanded = 'false';
        const gallery = this.closest('.product-information')?.querySelector('media-gallery')
          || document.querySelector('#MainContent media-gallery');
        const measure = () => {
          if (!this.isConnected) return;
          let previewHeight = 220;
          if (window.matchMedia('(min-width: 750px)').matches && gallery) {
            const photo = [...gallery.querySelectorAll('.product-media-container, .product-media')]
              .find(element => element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0);
            if (photo) {
              previewHeight = Math.max(160, Math.round(photo.getBoundingClientRect().bottom + 96 - body.getBoundingClientRect().top - 52));
            }
          }
          this.style.setProperty('--nm-copy-preview-height', previewHeight + 'px');
          const overflowing = content.getBoundingClientRect().height > previewHeight + 8;
          this.dataset.collapsible = String(overflowing);
          toggle.hidden = !overflowing;
        };
        const scheduleMeasure = () => {
          cancelAnimationFrame(this._readMoreFrame);
          this._readMoreFrame = requestAnimationFrame(measure);
        };
        toggle.addEventListener('click', () => {
          const expanded = this.dataset.expanded !== 'true';
          this.dataset.expanded = String(expanded);
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
          if (!expanded) {
            const targetBottom = body.getBoundingClientRect().top + parseFloat(this.style.getPropertyValue('--nm-copy-preview-height')) + 52;
            if (targetBottom < 0) this.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
        }, { signal: this._readMoreController.signal });
        window.addEventListener('resize', scheduleMeasure, { signal: this._readMoreController.signal });
        this._readMoreObserver = new ResizeObserver(scheduleMeasure);
        this._readMoreObserver.observe(content);
        if (gallery) this._readMoreObserver.observe(gallery);
        if (document.fonts?.ready) document.fonts.ready.then(scheduleMeasure);
        scheduleMeasure();
      };
      if (this.querySelector('.nm-product-copy__body')) setup();
      else this._readMoreFrame = requestAnimationFrame(setup);
    }
    disconnectedCallback() {
      this._readMoreController?.abort();
      this._readMoreController = null;
      this._readMoreObserver?.disconnect();
      cancelAnimationFrame(this._readMoreFrame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
